var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"fade"}},[(!_vm.open)?_c('section',{key:_vm.microButton.ref + 'button',staticClass:"micro-button",style:({
      top: _vm.microButton.position.top + '%',
      left: _vm.microButton.position.left + '%'
    }),on:{"click":_vm.playAnimation}}):_vm._e(),(_vm.open)?_c('section',{key:_vm.microButton.ref + 'textbox',staticClass:"text-box active",style:({
      top: _vm.microButton.position.top - 5+ '%',
      left: _vm.microButton.position.left - _vm.setTextboxLeftPosition() + '%'
    })},[_c('div',{staticClass:"text-box__text-area"},[_c('div',{staticClass:"text-box__text-area__wrapper"},[_c('div',{staticClass:"font text-box__text-area__wrapper__text 'full-width'"},[_c('p',{attrs:{"id":"textBoxText"},domProps:{"innerHTML":_vm._s(_vm.microButton.text)}})])])]),_c('div',{staticClass:"text-box__next-area"}),_c('div',{staticClass:"text-box__pointer-area",class:{
        'arrow-left':
          _vm.microButton.arrowPosition !== 'center' &&
          _vm.microButton.arrowPosition !== 'right',
        'arrow-center': _vm.microButton.arrowPosition === 'center',
        'arrow-right': _vm.microButton.arrowPosition === 'right'
      }},[_c('div',{staticClass:"arrow-down",class:{
          'arrow-left-margin':
            _vm.microButton.arrowPosition !== 'center' &&
            _vm.microButton.arrowPosition !== 'right',
          'arrow-right-margin': _vm.microButton.arrowPosition === 'right'
        }})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }